export default "__VITE_ASSET__BQeupXu4__"